import styles from './CurrentEventTask.module.css';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { 
    selectCurrentEventTaskItemName, 
    selectCurrentNumberOfItemsRequired,
    selectCurrentAllergyRequirements,
    selectCurrentNotes,
    setItemName,
    setNumberOfItemsRequired, 
    setAllergyRequirements
} from './currentEventTaskSlice'
import { Fragment } from 'react';

export function AdditionalFoodEventTaskInfo() {
    const itemName = useAppSelector(selectCurrentEventTaskItemName)
    const numberOfItemsRequired = useAppSelector(selectCurrentNumberOfItemsRequired)
    const allergyRequirements = useAppSelector(selectCurrentAllergyRequirements)
    const dispatch = useAppDispatch()
    return (
        <Fragment>
            <label className={styles.label} htmlFor='txtItemName'>Item name:</label>
            <input
                id='txtItemName'
                className={styles.textbox}
                aria-label='Set Item Name'
                value={itemName}
                onChange={(e) => dispatch(setItemName(e.target.value))}
            />
            <label className={styles.label} htmlFor='txtNumberOfItemsRequired'>Number of items required:</label>
            <input type="number"
                id='txtNumberOfItemsRequired'
                className={styles.textbox}
                aria-label='Set number of items required'
                value={numberOfItemsRequired}
                onChange={(e) => dispatch(setNumberOfItemsRequired(e.target.value))}
            />
            <label className={styles.label} htmlFor='txtAllergyRequirements'>Allergy Requirements:</label>
            <input
                id='txtAllergyRequirements'
                className={styles.textbox}
                aria-label='Set allergy requirements'
                value={allergyRequirements}
                onChange={(e) => dispatch(setAllergyRequirements(e.target.value))}
            />
        </Fragment>
    )
}